import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { DateTimeRangeState } from './DateTimeRangePicker';
import { checkDefinedOrThrow } from '../../helpers/expectDefinedOrThrow';

const dateTimeRangeStateContext = createContext<DateTimeRangeState | undefined>(undefined);

export function useDateTimeRangeStateContextOrNull() {
  return useContext(dateTimeRangeStateContext);
}

export function useDateTimeRangeStateContext() {
  return checkDefinedOrThrow(
    useContext(dateTimeRangeStateContext),
    new Error('useDateTimeRangeStateContext must be used in a DateTimeRangeStateProvider.'),
  );
}

export function DateTimeRangeStateProvider({
  value,
  children,
}: {
  value: DateTimeRangeState;
  children: ReactNode;
}) {
  return (
    <dateTimeRangeStateContext.Provider value={value}>
      {children}
    </dateTimeRangeStateContext.Provider>
  );
}
